/** Donut slice value as share of total (0–100) for percentage labels (LLP-017). */
export const toDonutPercentValue = (amount, total) => {
  const numericAmount = Number(amount) || 0;
  const numericTotal = Number(total) || 0;
  if (numericTotal <= 0) return 0;
  return (numericAmount / numericTotal) * 100;
};

export const buildDonutPercentData = (items) => {
  const total = items.reduce((sum, item) => sum + (Number(item.value) || 0), 0);
  return items.map((item) => ({
    ...item,
    value: toDonutPercentValue(item.value, total),
  }));
};
